(function() {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('ModalNotifyCtrl', ModalNotifyCtrl);

    ModalNotifyCtrl.$inject = ['$scope', '$modalInstance', 'message', 'title', 'confirm'];

    /**
     * Controller for a dialog.
     */
    function ModalNotifyCtrl($scope, $modalInstance, message, title, confirm) {
        $scope.message = message;
        $scope.title = title;
        $scope.confirm = confirm;

        /**
         * Closes the dialog with an affirmative (OK) choice.
         */
        $scope.ok = function() {
            $modalInstance.close('ok');
        };
    }
})();